import { render, staticRenderFns } from "./CertificateSelector.vue?vue&type=template&id=d315bd14&scoped=true"
import script from "./CertificateSelector.vue?vue&type=script&lang=ts"
export * from "./CertificateSelector.vue?vue&type=script&lang=ts"
import style0 from "./CertificateSelector.vue?vue&type=style&index=0&id=d315bd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d315bd14",
  null
  
)

export default component.exports